import type { Component, Structure, ViewMode } from '@wix/thunderbolt-becky-types'
import type { EditorName } from '@wix/thunderbolt-types'

const editorNameToFreemiumBannerComponentType: Partial<Record<EditorName, string>> = {
	Studio: 'FreemiumBannerResponsive',
	Odeditor: 'FreemiumBannerDesktop',
}

export const createComponent = ({
	componentType,
	id,
	uiType,
	type = 'Component',
}: Pick<Component, 'id' | 'componentType' | 'uiType' | 'components'> & { type?: Component['type'] }): Component => {
	return {
		id,
		components: [],
		componentType,
		layout: {},
		type,
		parent: null,
		styleId: '',
		metaData: {
			pageId: 'masterPage',
		},
		...(uiType ? { uiType } : {}),
	}
}

export type AddFreemiumBannerParams = {
	editorName: EditorName
	isResponsive: boolean
	shouldShowCoBrandingBanner: boolean
	shouldShowDayfulBanner: boolean
	viewMode: ViewMode
}

export const getRootComponents = (
	params: { shouldRenderFreemiumBanner: boolean } & AddFreemiumBannerParams
): Structure => {
	return {
		BACKGROUND_GROUP: createComponent({ componentType: 'BackgroundGroup', id: 'BACKGROUND_GROUP' }),
		...(params.shouldRenderFreemiumBanner && { WIX_ADS: getFreemiumBannerComponent(params) }),
		SCROLL_TO_TOP: createComponent({ componentType: 'Anchor', id: 'SCROLL_TO_TOP', components: undefined }),
		SCROLL_TO_BOTTOM: createComponent({ componentType: 'Anchor', id: 'SCROLL_TO_BOTTOM', components: undefined }),
	}
}

export const getFreemiumBannerComponent = ({
	viewMode,
	shouldShowCoBrandingBanner,
	isResponsive,
	shouldShowDayfulBanner,
	editorName,
}: AddFreemiumBannerParams): Component => {
	if (shouldShowDayfulBanner) {
		return createComponent({
			componentType: 'CoBrandingBannerMobile',
			id: 'WIX_ADS',
			uiType: 'Dayful',
			type: 'Container',
		})
	}

	if (shouldShowCoBrandingBanner) {
		if (viewMode === 'mobile') {
			return createComponent({
				componentType: 'CoBrandingBannerMobile',
				id: 'WIX_ADS',
				type: 'Container',
			})
		}

		const uiType = isResponsive ? 'Responsive' : 'Classic'
		return createComponent({ componentType: 'CoBrandingBannerDesktop', id: 'WIX_ADS', uiType, type: 'Container' })
	}

	if (isResponsive) {
		const uiType = editorName === 'Studio' ? 'Studio' : undefined
		return createComponent({
			componentType: editorNameToFreemiumBannerComponentType[editorName] ?? 'FreemiumBannerResponsive',
			id: 'WIX_ADS',
			uiType,
			type: 'Container',
		})
	}

	const componentType = viewMode === 'mobile' ? 'FreemiumBannerMobile' : 'FreemiumBannerDesktop'
	return createComponent({ componentType, id: 'WIX_ADS', type: 'Container' })
}
